<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-wrench mr-2" />Kategori Foto</h5>
            <hr />
            <b-row>
                <b-col md="2">
                    <b-form-group label="Nama">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Jenis">
                        <b-form-select v-model="filter.kindId" :options="optKind" value-field="id" text-field="name"
                            @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Aksi">
                        <b-button class="mr-2" variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button variant="danger" @click="onReset">
                            <i class="fa fa-undo
                            mr-2" />Reset
                        </b-button>
                    </b-form-group>
                </b-col>

                <b-col md="6" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Kategori Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="onSortChanged" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data kategori foto.
                </template>

                <template v-slot:cell(is_required)="row">
                    <span v-if="row.item.is_required == 1" class="badge badge-success">Wajib</span>
                    <span v-else class="badge badge-secondary">Tidak Wajib</span>
                </template>

                <template v-slot:cell(item_kind.name)="row">
                    <div v-if="row.item.item_kind">
                        {{ row.item.item_kind.name || "-" }}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>

                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" class="mr-2" v-b-tooltip.hover.top title="Edit"
                        @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Delete"
                        @click="prepareDelete(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah Kategori Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Kategori">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Jenis Barang">
                <b-form-select v-model="input.kindId" :options="optKind" value-field="id" text-field="name" />
            </b-form-group>
            <b-form-group label="Wajib">
                <b-form-checkbox v-model="input.isRequired" switch size="lg" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Kategori" no-close-on-backdrop no-close-on-esc hide-footer>
            Mengubah kategori <strong>{{ activeItem.name }}</strong>
            <b-form-group label="Nama Kategori" class="mt-4">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Jenis Barang">
                <b-form-select v-model="edit.kindId" :options="optKind" value-field="id" text-field="name" />
            </b-form-group>
            <b-form-group label="Wajib">
                <b-form-checkbox v-model="edit.isRequired" switch size="lg" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-delete" title="Delete Kategori" no-close-on-backdrop no-close-on-esc hide-footer>
            Anda yakin ingin menghapus kategori <strong>{{ activeItem.name }}</strong>?
            <div class="mt-4 text-right">
                <b-button variant="outline-primary" class="mr-2" :disabled="isSubmitting"
                    @click="$bvModal.hide('m-delete')">
                    Batal
                </b-button>
                <b-button variant="danger" :disabled="isSubmitting" @click="confirmDelete">
                    {{ isSubmitting ? "Menghapus..." : "Hapus" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                name: "",
                kindId: null
            },

            input: {
                name: "",
                kindId: null,
                isRequired: false,
            },

            edit: {
                name: "",
                kindId: null,
                isRequired: false,
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "name", label: "Nama Kategori", sortable: true },
                { key: "item_kind.name", label: "Jenis Barang", sortable: true },
                { key: "is_required", label: "Wajib", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: []

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getMasterKind = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getItems, getMasterKind]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    this.initStatus = -1
                })

        },

        confirmCreate() {

            if (this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if (this.input.kindId == null) {
                return this.$helper.toastError(this, "Jenis Barang tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan kategori foto baru ini?")
            if (!isConfirmed) return

            let payload = {
                name: this.input.name,
                kind_id: this.input.kindId,
                is_required: this.input.isRequired
            }

            this.isSubmitting = true
            this.$axios.post("master/kategori-foto", payload).then(res => {

                this.$helper.toastSuccess(this, "Kategori baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.input.name = ""
                this.input.isRequired = false
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {
            this.activeItem = item
            this.edit.name = item.name
            this.edit.isRequired = item.is_required == 1
            this.edit.kindId = item.kind_id
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if (this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan perubahan kategori ini?")
            if (!isConfirmed) return

            let payload = {
                name: this.edit.name,
                kind_id: this.edit.kindId,
                is_required: this.edit.isRequired
            }

            this.isSubmitting = true
            this.$axios.post("master/kategori-foto/" + this.activeItem.id, payload).then(res => {

                this.$helper.toastSuccess(this, "Data kategori berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.edit.name = ""
                this.edit.isRequired = false
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        prepareDelete(item) {
            this.activeItem = item
            this.$bvModal.show("m-delete")
        },

        confirmDelete() {

            let isConfirmed = confirm("Apakah anda yakin ingin menghapus kategori foto ini? Perubahan ini tidak dapat dibatalkan!")
            if (!isConfirmed) return

            this.isSubmitting = true

            this.$axios.delete("master/kategori-foto/" + this.activeItem.id).then(res => {

                this.$helper.toastSuccess(this, "Kategori berhasil dihapus!")
                this.$bvModal.hide("m-delete")
                this.getItems()

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        onReset() {
            this.filter = {
                name: "",
                kindId: null
            }
            this.getItems()
        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if (this.filter.kindId != null) {
                param += "&filterKind=" + this.filter.kindId
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                if (this.sortBy == 'kind') param += "&sortBy=item_kind_name"
                else param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("master/kategori-foto" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("kategoriKerusakanFilter", JSON.stringify(this.filter))
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("kategoriKerusakanFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("kategoriKerusakanFilter"))
        }
        this.init()
    }
}
</script>
